import { useState, useEffect } from 'react';
import useDataBean from '../../../../core/services/dataBean/useDataBean';
import { _LeftByValue, _StatementMovement } from '../../../../core/services/dataBean/EntityCatalogVdos';
import useModal, { MODAL_md } from '../../../theme/Component/hooks/useModal';
import { BasicTable, MASK_NUMBER } from '../../../theme/Component/BasicTable';
import { Modal } from '../../../theme/Component/Modal';
import { FileService } from '../../../../core/services/FileService';
import { _single } from '../../../../core/services/dataBean/EntityCatalog';
import { BankAccountSelect } from '../../../erp/cellEditor/BankAccount/BankAccountSelect';
import { YearSelector } from '../../../../core/shared/inputs/YearSelector';
import { BasicButton } from '../../../theme/Component/BasicButton';
import { single } from 'rxjs';
import { ListMenu } from '../../../theme/Component/ListMenu';
import { PrintJson } from '../../../theme/Component/PrintJson';


interface Props {
    idSelector: number;
    onChange: any;
    TrValue?: any;
    BankingAccount?: any;
    label?: string;
    returnType?: "ID" | "Object";
    render?: string;
}

export const BankingStatementMovementEditor = ({ idSelector, onChange, label, returnType = "ID", render, TrValue, BankingAccount }: Props) => {

    const { instance, lista, setLista, bean, setBean } = useDataBean(_StatementMovement)
    const left = useDataBean(_LeftByValue)
    const [id, setID] = useState(null);
    const fileService = new FileService();
    const [listados, setListados] = useState<any>([]);
    const [modalconsultar, setModalconsultar] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [form, setForm] = useState<any>({
        IDAccount: NaN,
        Year: _single.getCurrenYear(),
        MonthVigency: NaN,
        Type: null,
    })
    const modal = useModal("Valores por Conciliar de Extracto Bancario", MODAL_md);
    const [idBankingAccount, setidBankingAccount] = useState<number>(BankingAccount)
    useEffect(() => {
        setID(idSelector)
    }, [idSelector])

    useEffect(() => {
        getLista();
    }, [])
    useEffect(() => {
        if (BankingAccount) {
            getLista();
        }
    }, [BankingAccount]);
    useEffect(() => {
        if (modalconsultar.view) {
            MovementLeftByValue();
        }
    }, [modalconsultar.view]);
    const setValue = (e: string) => {
        const selectedId = parseInt(e);
        setID(selectedId);
        if (onChange) {
            const selectedItem = listados.find(
                (item) => item?.DataBeanProperties?.IDBankingStatementMovement == e
            );
            if (selectedItem) {
                onChange(returnType === "Object" ? selectedItem?.DataBeanProperties : selectedId);
            } else {
                onChange(returnType === "Object" ? {} : null);
            }
        }
    };
    const listaBotones = () => {
        const botones = [

            { titulo: 'Consultar Movimiento de Extracto', icono: 'ri-edit-2-line', visible: true, evento: () => { setModalconsultar({ ...modalconsultar, "view": true }) } },


        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }

    const getLista = () => {

        instance.BankingStatement(idBankingAccount, form.Year).then(
            (resp: any) => {
                if (resp) {
                    let tmp = resp;
                    tmp.forEach((element: any) => {
                        if (element.DataBeanProperties.MediaContext) {
                            element.DataBeanProperties.URL = ` <a href="${fileService.getUrlFile(element.DataBeanProperties.MediaContext, element.DataBeanProperties.Media)}" target='_blank'>VER DOCUMENTO</a>`
                        } else {
                            element.DataBeanProperties.URL = "Sin Documento";
                        }
                    });
                    setLista(tmp);
                } else {
                    setLista([]);
                }

            }
        )


    }

    const MovementLeftByValue = () => {

        left.instance.getBankingStatementMovementLeftByValue(bean.IDBankingStatement, TrValue).then(
            (resp: any) => {
                if (resp) {
                    console.log(resp)
                    setListados(resp)
                }

            }
        )

    }
    const head = [
        { title: 'ID', property: 'IDBankingStatement', visible: true },
        { title: 'Fecha Inicio Corte', property: 'StartingDate', visible: true },
        { title: 'Fecha fin de Corte', property: 'EndingDate', visible: true },
        { title: 'Saldo Inicial', property: 'InitialLeft', visible: true },
        { title: 'Saldo Final', property: 'EndingLeft', visible: true },
        { title: 'Ver / Descargar Archivo del Extracto', property: 'URL', visible: true },
    ]
    const headtwo = [
        { title: 'ID', property: 'IDBankingStatementMovement', visible: true },
        { title: 'Fecha Movimiento', property: 'TrDate', visible: true },
        { title: 'Oficina', property: 'Office', visible: true },
        { title: 'Valor Movimiento', property: 'TrValue', visible: true },
        { title: 'Descripción', property: 'Description', visible: true },
        { title: 'Referencia 1', property: 'TrRef1', visible: true },
        { title: 'Referencia 2', property: 'TrRef2', visible: true },
        { title: 'Referencia 3', property: 'TrRef3', visible: true },
        { title: 'ID Conciliación', property: 'IDBankingConciliation', visible: true },
        // { title: 'Documento Registro Contable', property: 'URL', visible: true },
        { title: 'Fecha Documento', property: 'DocumentDate', visible: true },

    ]
    const abrirModal = () => {
        modal.open();
    }


    return (
        <>
            <label>{label ?? "Valores por Conciliar de Extracto Bancario"}</label>
            <span className='form-control cursor ifmodal' onClick={abrirModal}>{render ?? ''}</span>
            <Modal modal={modal.modal} updateModal={modal.setModal}>
                <div className="row">
                    <div className="col-md-6">
                        <BankAccountSelect label="Cuenta Bancaria" idSelector={idBankingAccount} onChange={(e) => { setidBankingAccount(e) }} />
                    </div>
                    <div className="col-md-6">
                        <YearSelector tittle="Año" onChange={(e) => { setForm({ ...form, "Year": e }) }} />
                    </div>
                    <div className="col-md-6 mt-4">
                        <BasicButton icon="ri-search-line" eventClick={getLista} >Buscar</BasicButton>
                    </div>
                    <div className="col-md-12">

                    </div>
                </div>
                <BasicTable head={head} body={lista} rowSet={(e) => { setBean(e) }} listButtons={listaBotones()}></BasicTable>
                <div className="row">
                    <div className="col-md-12">
                        <Modal modal={modalconsultar} updateModal={setModalconsultar}>
                            <>
                                <div className="row">
                                    <div className="col-md-4">
                                        <strong>IDBankingStatement</strong>
                                        <PrintJson json={bean.IDBankingStatement} />
                                    </div>
                                    <div className="col-md-4">
                                        <strong>TrValue</strong>
                                        <PrintJson json={TrValue} />
                                    </div>
                                    <div className="col-md-12">
                                        <BasicTable head={headtwo} body={listados} rowSet={(e) => { setValue(e.IDBankingStatementMovement); console.log(e.IDBankingStatementMovement);; modal.close() }}></BasicTable>
                                    </div>
                                </div>



                            </>
                        </Modal>
                    </div>
                </div>
            </Modal>
        </>
    )
}